
import { instantiate } from './ArcaneDesignSystem-catalog-chat-composeApp.uninstantiated.mjs';


const exports = (await instantiate({
})).exports;

export const {
arcaneChatSendMessage,
arcaneChatSetInput,
arcaneChatGetMessageCount,
arcaneChatClearMessages,
memory,
_initialize
} = exports


